export const TITLE = "Buy Electric Auto Online | India's Trusted EV Marketplace - Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "India's most trusted electric commercial vehicle marketplace. Buy electric auto rickshaws, three wheeler EVs & commercial vehicles online from top brands like Mahindra, Piaggio, Euler. Lowest prices, best financing, guaranteed buyback. Browse EV models across Karnataka, Delhi, Maharashtra, Tamil Nadu, Gujarat & Telangana.",
  },
  {
    name: "keywords",
    content:
      "India's Most Trusted Electric Auto Marketplace, electric auto online, electric commercial vehicle marketplace, electric auto rickshaw, three wheeler EV, commercial electric vehicle, Mahindra electric auto, Piaggio electric auto, Euler electric auto, electric auto price, electric auto financing, electric auto buyback, electric auto Karnataka, electric auto Delhi, electric auto Maharashtra, electric auto Tamil Nadu, electric auto Gujarat, electric auto Telangana, Turno electric auto, EV marketplace India, electric vehicle dealer, electric auto dealer",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Buy Electric Auto Online | India's Trusted EV Marketplace - Turno",
  },
  {
    property: "og:description",
    content:
      "India's most trusted electric commercial vehicle marketplace. Buy electric auto rickshaws, three wheeler EVs & commercial vehicles online from top brands like Mahindra, Piaggio, Euler. Lowest prices, best financing, guaranteed buyback. Browse EV models across Karnataka, Delhi, Maharashtra, Tamil Nadu, Gujarat & Telangana.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "India's most trusted electric commercial vehicle marketplace. Buy electric auto rickshaws, three wheeler EVs & commercial vehicles online from top brands like Mahindra, Piaggio, Euler. Lowest prices, best financing, guaranteed buyback. Browse EV models across Karnataka, Delhi, Maharashtra, Tamil Nadu, Gujarat & Telangana.",
  },
  {
    name: "twitter:title",
    content: "Buy Electric Auto Online | India's Trusted EV Marketplace - Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const HOME_LINK = "https://www.turno.club/";

export const CONNECT_HEADING = "Talk to Us";

export const CONNECT_SUBHEADING = "We help you find the best vehicle for your business with affordable financing. Connect with us now.";

export const CONNECT_CTA_TEXT = "Call us";